
export interface TableStyleOptions {
  // Container styles
  containerBg?: string;
  containerBorder?: string;
  containerBorderRadius?: string;
  containerShadow?: string;
  
  // Table styles
  tableBg?: string;
  tableBorder?: string;
  tableBorderRadius?: string;
  
  // Header styles
  headerBg?: string;
  headerTextColor?: string;
  headerBorderBottom?: string;
  headerFontWeight?: string;
  headerFontSize?: string;
  headerPadding?: string;
  headerHeight?: string;
  
  // Row styles
  rowBg?: string;
  rowHoverBg?: string;
  rowSelectedBg?: string;
  rowBorderBottom?: string;
  rowTextColor?: string;
  rowFontSize?: string;
  
  // Cell styles
  cellPadding?: string;
  cellBorderRight?: string;
  cellTextAlign?: string;
  
  // Button styles
  buttonBg?: string;
  buttonHoverBg?: string;
  buttonTextColor?: string;
  buttonBorder?: string;
  buttonBorderRadius?: string;
  buttonPadding?: string;
  
  // Pagination styles
  paginationBg?: string;
  paginationBorder?: string;
  paginationTextColor?: string;
  paginationButtonBg?: string;
  paginationButtonHoverBg?: string;
  
}

// Define interface for table configuration options
export interface TableOptions {
  // Core features
  enableSorting?: boolean;
  enablePagination?: boolean;
  enableFiltering?: boolean;
  enableGlobalFilter?: boolean;
  enableCustomGlobalFilter?: boolean;

  // Row features
  enableRowExpansion?: boolean;
  enableRowSelection?: boolean;
  enableMultiRowSelection?: boolean;
  
  // Column features
  enableColumnPinning?: boolean;
  enableColumnResizing?: boolean;
  columnResizeMode?: 'onChange' | 'onEnd';
  
  // Pagination options
  initialPageSize?: number;
  pageSizeOptions?: number[];
  
  // Filter options
  globalFilterFn?: string;
  
  // Debug options
  enableDebug?: boolean;
  debugTable?: boolean;
  debugHeaders?: boolean;
  debugColumns?: boolean;
  
  // Custom options
  autoResetPageIndex?: boolean;
  enableCustomActions?: boolean;
  
  // UI options
  showTableMenu?: boolean;
  showActionMenu?: boolean;
  enableCellEditing?: boolean;
  enableCustomColPinning?: string | undefined;

  customStyles?: TableStyleOptions;

}

// Default configuration
export const DEFAULT_TABLE_OPTIONS: TableOptions = {
  enableSorting: true,
  enablePagination: true,
  enableFiltering: true,
  enableGlobalFilter: false,
  enableCustomGlobalFilter: false,
  enableRowExpansion: true,
  enableRowSelection: false,
  enableMultiRowSelection: false,
  enableColumnPinning: true,
  enableColumnResizing: true,
  columnResizeMode: 'onChange',
  initialPageSize: 10,
  pageSizeOptions: [10, 20, 30, 40, 50],
  globalFilterFn: 'includesString',
  enableDebug: false,
  debugTable: false,
  debugHeaders: false,
  debugColumns: false,
  autoResetPageIndex: false,
  enableCustomActions: true,
  showTableMenu: true,
  showActionMenu: true,
  enableCellEditing: true,
  enableCustomColPinning: undefined,
};
